import type { PageCard } from '@/play/pageTypes'
import { SplatCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'splat',
  number: 12,
  title: 'Splat',
  question: 'Can motion design alone (stretch, squash, ripple) make a drop feel physical?',
  status: 'open',
  accent: '#ffe1d6',
  CardArt: SplatCardArt,
}
